import { render, staticRenderFns } from "./menus_edit.vue?vue&type=template&id=100f4466&scoped=true"
import script from "./menus_edit.vue?vue&type=script&lang=ts"
export * from "./menus_edit.vue?vue&type=script&lang=ts"
import style0 from "./menus_edit.vue?vue&type=style&index=0&id=100f4466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100f4466",
  null
  
)

export default component.exports